import React, { useEffect, useState } from 'react';
import '../pages/Home.css';
import { fetchBanners } from '../graphql/api/bannerApi';
import { GET_BANNERS } from '../graphql/bannerGQL';
import { Banner ,TextStyle} from '../interfaces/product';

const BannerSlider: React.FC = () => {
  const [banners, setBanners] = useState<Banner[]>([]);
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    async function loadBanners() {
      try {
        const data = await fetchBanners();
        setBanners(data);
      } catch (error) {
        console.error('Failed to fetch banners:', error);
      }
    }
    loadBanners();
  }, []);

  useEffect(() => {
    if (!banners.length) return;
    const interval = setInterval(() => {
      setCurrent(prev => (prev + 1) % banners.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [banners]);

  const prevSlide = () => {
    setCurrent(prev => (prev === 0 ? banners.length - 1 : prev - 1));
  };

  const nextSlide = () => {
    setCurrent(prev => (prev + 1) % banners.length);
  };

  if (!banners.length) return null;
const buildTextStyle = (style: TextStyle) => {
  const validAligns: React.CSSProperties["textAlign"][] = [
    "left",
    "right",
    "center",
    "justify",
    "start",
    "end",
  ];

  return {
    color: style.color,
    fontFamily: style.font,
    textAlign: validAligns.includes(style.align as any)
      ? (style.align as React.CSSProperties["textAlign"])
      : undefined,
    fontSize: style.fontSize,
    fontWeight: style.fontWeight,
    textShadow: style.textShadow,
    letterSpacing: style.letterSpacing,
    lineHeight: style.lineHeight,
  };
};


  return (
    <section className="slider-container">
      <div className="slider">
        {banners.map((banner, index) => (
          <div
            key={banner.id}
            className={`slide ${index === current ? 'active' : ''}`}
            style={{ backgroundImage: `url(${banner.imageUrl})` }}
          >
            <div className="slide-overlay">
              <h2 style={buildTextStyle(banner.styles.header)}>
                {banner.header}
              </h2>
              <p
                className="midline"
                style={buildTextStyle(banner.styles.midline)}
              >
                {banner.midline}
              </p>
              <p
                className="feature"
                style={buildTextStyle(banner.styles.feature)}
              >
                {banner.feature}
              </p>
              <div
                className="discount"
                style={buildTextStyle(banner.styles.discount)}
              >
                {banner.discount}
              </div>
            </div>
          </div>
        ))}
        <button className="prev-btn" onClick={prevSlide}>
          ❮
        </button>
        <button className="next-btn" onClick={nextSlide}>
          ❯
        </button>
      </div>
    </section>
  );
};

export default BannerSlider;
